import { VSystemBar } from 'vuetify/lib/components/VSystemBar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userOnline)?_c(VSystemBar,{staticClass:"d-flex justify-center",attrs:{"height":"30","dark":"","color":"error","app":"","fixed":"","dense":""}},[_vm._v("\n  Modo sin conexion\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }